// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"219":"be3906c0","611":"156ae58e","661":"71205807","771":"17291dcd","787":"437b03a2"}[chunkId] + ".chunk.js";
};